module.exports = __webpack_public_path__ + "img/img2.a1d24f2d.png";